import { type ApisauceInstance, create } from 'apisauce';

import { _config } from '~/utils/envConfig';

let clmApiClient: ApisauceInstance;
let clmAccountApiClient: ApisauceInstance;
let clmUserApiClient: ApisauceInstance;
let clmUserCoreApiClient: ApisauceInstance;

export function initApiClients() {
  clmApiClient = create({
    baseURL: _config.api.clmApiUrl,
    headers: { 'Sharing-Web-Version': __APP_VERSION__ },
  });

  clmAccountApiClient = create({
    baseURL: _config.api.clmAccountApiUrl,
    headers: { 'Sharing-Web-Version': __APP_VERSION__ },
  });

  clmUserApiClient = create({
    baseURL: _config.api.clmUserApiUrl,
    headers: { 'Sharing-Web-Version': __APP_VERSION__ },
  });

  clmUserCoreApiClient = create({
    baseURL: _config.api.clmUserCoreApiUrl,
    headers: { 'Sharing-Web-Version': __APP_VERSION__ },
  });
}

const apiClients = () => [
  clmApiClient,
  clmAccountApiClient,
  clmUserApiClient,
  clmUserCoreApiClient,
];

export function setAuthHeader(header: string, value: string) {
  apiClients().forEach((client) => client.setHeader(header, value));
}

export function deleteAuthHeader(header: string) {
  apiClients().forEach((client) => client.deleteHeader(header));
}

export {
  clmApiClient,
  clmAccountApiClient,
  clmUserApiClient,
  clmUserCoreApiClient,
};
